import React from 'react';
import '../../../styles/irctcAboutInfo.css';
import { IRCTC_PAGE_URLS, WRONG_CREDETIALS_HEADER } from '../../../utils/RailsSEOConstants';
import { isMobile, navigateTo } from '../../../utils/commonUtils';
import { getAppEnv } from '../../../../config/env';
import PropTypes from 'prop-types';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const WrongCredentialsInfo = ({ customClass }) => {
  const isMobileDevice = isMobile();
  return (
    <div className={`${customClass} aboutContainer`}>
      {!isMobileDevice && <h6 className="font14 latoBold appendBottom8">{WRONG_CREDETIALS_HEADER}</h6>}
      <p className={`${isMobileDevice ? 'blackText' : ''}`}>
        ‘Login failed wrong user credentials’ error message means that there is a problem with IRCTC Login credentials
        (IRCTC User ID or password). Recheck your IRCTC User ID and password.
        <br />
        If the issue still remains, you can change your password by clicking{' '}
        <a onClick={() => navigateTo(IRCTC_PAGE_URLS.FORGOT_PASSWORD_PAGE)}>here</a> or recover your username by
        clicking <a onClick={() => navigateTo(IRCTC_PAGE_URLS.FORGOT_USERNMAE_PAGE)}>here.</a>
        <br />
        You can also create a new IRCTC account by clicking{' '}
        <a onClick={() => navigateTo(IRCTC_PAGE_URLS.CREATE_ACCOUNT_PAGE)}>here.</a>
      </p>
      <div className="imgWrap__captcha">
        <img src={`${PUBLIC_URL}/static/public/wrongCredentials.png`} alt={''} />
      </div>
    </div>
  );
};

WrongCredentialsInfo.propTypes = {
  customClass: PropTypes.string
};

export default WrongCredentialsInfo;
